import { useApiClient } from '@frontend-common/api-client-provider';
import { useTreatyQuery } from '@frontend-common/utils/use-treaty-query';

export function useMachineStatusList(
  shopId: number | null,
  opts?: { throwOnError?: boolean; refetchInterval?: number; staleTime?: number; couponNonceKey?: string },
) {
  const client = useApiClient();
  const query = useTreatyQuery({
    queryKey: ['machineStatusList', shopId],
    queryFn: () =>
      client.shops({ id: shopId! })['machines-state'].get({ query: { couponNonceKey: opts?.couponNonceKey } }),
    staleTime: opts?.staleTime ?? 10000,
    refetchInterval: opts?.refetchInterval ?? 8000,
    refetchOnMount: 'always',
    enabled: !!shopId,
    retry: false,
    throwOnError: opts?.throwOnError,
  });

  return {
    ...query,
    isPending: query.isPending || (query.isFetching && query.isStale),
  };
}
